<template>
  <div class="auth-wrapper auth-v2">
    <div class="auth-inner">
      <!-- brand logo -->
      <router-link
        to="/"
        class="brand-logo d-flex align-center"
      >
        <!-- <v-img
          :src="appLogo"
          max-height="30px"
          max-width="30px"
          alt="logo"
          contain
          class="me-3"
        ></v-img>

        <h2 class="text--primary">
          {{ appName }}
        </h2> -->
      </router-link>
      <!--/ brand logo -->
      <!-- <v-row class="auth-row ma-0"> -->
      <v-row
        style=" height: 100%; overflow-y: hidden;"
        class="ma-0"
      >
        <v-col
          lg="8"
          class="d-none d-lg-block position-relative overflow-hidden pa-0"
        >
          <div class="auth-illustrator-wrapper">
            <!-- <img height="362" class="auth-mask-bg"
              :src="require(`@/assets/images/misc/mask-v2-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)" />

            <v-img height="226" width="300" class="auth-tree" src="@/assets/images/misc/tree-4.png"></v-img> -->
            <!-- max-width="100%" height="692" -->
            <!-- 3d character -->
            <div class="d-flex align-center h-full pa-16 pe-0">
              <v-img
                contain
                class="auth-3d-group"
                :src="require(`../../src/assets/images/AsianAlliance/AsianAllianceLogoWaterMark.png`)"
              ></v-img>
              <!-- <v-img contain max-width="100%" height="692" class="auth-3d-group"
                :src="require(`@/assets/images/3d-characters/group-${$vuetify.theme.dark ? 'dark' : 'light'}.png`)"></v-img> -->
            </div>
          </div>
        </v-col>

        <v-col
          v-if="!isMobile && stepper == 1"
          lg="4"
          class="d-flex align-center auth-bg pa-10 pb-0"
        >
          <v-row>
            <v-col
              cols="12"
              sm="8"
              md="6"
              lg="12"
              class="mx-auto"
            >
              <v-card flat>
                <v-card-text>
                  <p class="text-2xl font-weight-semibold text--primary mb-2">
                    Welcome to Asian Alliance
                  </p>
                  <p class="mb-2">
                    Membership / Staff No or MobileNo
                  </p>
                </v-card-text>
                <!-- <v-card flat>
                <v-card-text>
                  <p class="text-2xl font-weight-semibold text--primary mb-2">
                    Welcome to Asian Alliance
                  </p>
                  <p class="mb-2">
                    Membership / Staff No
                  </p>
                </v-card-text> -->

                <v-card-text>
                  <v-form
                    ref="loginForm"
                    @submit.prevent="handleFormSubmit"
                  >
                    <v-text-field
                      v-model="email"
                      outlined
                      label="Username"
                      placeholder="username"
                      :error-messages="errorMessages.username"
                      :rules="[validators.required]"
                      hide-details="auto"
                      class="mb-6"
                    ></v-text-field>

                    <v-text-field
                      v-model="password"
                      outlined
                      :type="isPasswordVisible ? 'text' : 'password'"
                      label="Password"
                      :error-messages="errorMessages.password"
                      placeholder="Password"
                      :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
                      :rules="[validators.required]"
                      hide-details="auto"
                      class="mb-2"
                      @click:append="isPasswordVisible = !isPasswordVisible"
                    ></v-text-field>

                    <div class="d-flex align-center justify-space-between flex-wrap">
                      <div style="padding-top:30px;">
                        <v-checkbox
                          hide-details
                          label="Remember Me"
                          class="mt-0"
                        >
                        </v-checkbox>
                      </div>
                      <div
                        style="padding-top:32px;font-size:16px ;position: relative;"
                        @click="stepper = 4"
                      >
                        <u>Forget Password?</u>
                      </div>
                    </div>

                    <v-btn
                      block
                      color="primary"
                      type="submit"
                      class="mt-6"
                      :loading="loading"
                    >
                      Login
                    </v-btn>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-if="stepper == 4 && !isMobile"
          class="d-flex auth-bg pa-10 pb-0 closeToTop"
          lg="4"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="12"
                class="mx-auto"
              >
                <v-card flat>
                  <v-card-text>
                    <p class="text-2xl font-weight-semibold text--primary mb-2">
                      Forgot Password
                    </p>
                  </v-card-text>

                  <!-- login form -->
                  <v-card-text class="activationForm">
                    <v-form
                      ref="forgotPasswordForm"
                      @submit.prevent="handleForgotPasswordFormSubmit"
                    >
                      <v-text-field
                        v-model="activationUserNo"
                        outlined
                        label="Membership No. or Mobile No."
                        placeholder="Membership No. or Mobile No."
                        :error-messages="errorMessages.activationUserNo"
                        :rules="[validators.lengthMoreThanValidator(activationUserNo, 10), validators.required]"
                        hide-details="auto"
                        class="mb-6"
                      ></v-text-field>
                      <v-text-field
                        v-model="activationHKID"
                        outlined
                        label="HKID"
                        :error-messages="errorMessages.activationHKID"
                        placeholder="HKID"
                        :rules="[validators.lengthValidator(activationHKID, 5), validators.required]"
                        hide-details="auto"
                        class="mb-2"
                        @click:append="isPasswordVisible = !isPasswordVisible"
                      ></v-text-field>
                      <div style="padding-top:0px;font-size:16px ;position: relative;">
                        e.g. Z123456(7) input as Z1234
                      </div>
                      <div class="d-flex align-center justify-space-between flex-wrap">
                        <v-btn
                          block
                          color="primary"
                          type="submit"
                          class="mt-6"
                          :loading="loading"
                        >
                          Next
                        </v-btn>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <!--verfication -->
        <v-col
          v-if="stepper == 5 && !isMobile"
          class="d-flex auth-bg closeToTop"
          lg="4"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="12"
                class="mx-auto"
              >
                <v-card flat>
                  <v-card-text>
                    <p class="text-2xl font-weight-semibold text--primary mb-2">
                      Enter 6-digit verification code
                    </p>
                  </v-card-text>
                  <v-card-text>
                    <CodeInput
                      style="margin-top: 30px;"
                      class="input"
                      @complete="verificationCodeComplete"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

          <v-overlay
            :z-index="999"
            :value="loading"
          >
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </v-col>

        <!-- change password -->
        <v-col
          v-if="stepper == 6 && !isMobile"
          class="d-flex auth-bg closeToTop"
          lg="4"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="12"
                class="mx-auto"
              >
                <v-card flat>
                  <v-card-text>
                    <p class="text-2xl font-weight-semibold text--primary mb-2">
                      Activation
                    </p>
                  </v-card-text>

                  <v-card-text class="activationForm">
                    <v-form
                      ref="changePasswordForm"
                      @submit.prevent="handleChangePasswordFormSubmit"
                    >
                      <v-text-field
                        v-model="activationPassword"
                        outlined
                        :type="isPasswordVisible ? 'text' : 'password'"
                        label="Create Password"
                        :error-messages="errorMessages.activationPassword"
                        placeholder="Password"
                        :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
                        :rules="[v => {
                          if (!(contains_eight_characters &&
                            contains_special_character &&
                            contains_uppercase &&
                            contains_number)) return ''
                        }, validators.required]"
                        hide-details="auto"
                        class="mb-2"
                        @input="checkPassword"
                        @click:append="isPasswordVisible = !isPasswordVisible"
                      ></v-text-field>

                      <div>
                        <v-icon
                          v-if="contains_eight_characters"
                          color="#4CAF50"
                        >
                          {{ icons.mdiCheck }}
                        </v-icon>
                        <v-icon
                          v-else
                          color="#F44336"
                        >
                          {{ icons.mdiWindowClose }}
                        </v-icon>
                        At least 8 characters
                        <br>
                        <v-icon
                          v-if="contains_special_character"
                          color="#4CAF50"
                        >
                          {{ icons.mdiCheck }}
                        </v-icon>
                        <v-icon
                          v-else
                          color="#F44336"
                        >
                          {{ icons.mdiWindowClose }}
                        </v-icon>At least 1 specific character
                        !@#$%^&*
                        <br>
                        <v-icon
                          v-if="contains_uppercase"
                          color="#4CAF50"
                        >
                          {{ icons.mdiCheck }}
                        </v-icon>
                        <v-icon
                          v-else
                          color="#F44336"
                        >
                          {{ icons.mdiWindowClose }}
                        </v-icon>At least 1 uppercase character
                        <br>
                        <v-icon
                          v-if="contains_number"
                          color="#4CAF50"
                        >
                          {{ icons.mdiCheck }}
                        </v-icon>
                        <v-icon
                          v-else
                          color="#F44336"
                        >
                          {{ icons.mdiWindowClose }}
                        </v-icon>At least 1 numberic character
                        <br>
                      </div>

                      <v-text-field
                        v-model="activationConfirmedPassword"
                        style="padding-top:12px;"
                        outlined
                        :type="isPasswordVisible ? 'text' : 'password'"
                        label="Confirmed Password"
                        :error-messages="errorMessages.activationConfirmedPassword"
                        placeholder="Password"
                        :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
                        :rules="[activationPassword === activationConfirmedPassword || 'Please enter same password', validators.required]"
                        hide-details="auto"
                        class="mb-2"
                        @click:append="isPasswordVisible = !isPasswordVisible"
                      ></v-text-field>

                      <div class="d-flex align-center justify-space-between flex-wrap">
                        <v-btn
                          block
                          color="primary"
                          type="submit"
                          class="mt-6"
                          :loading="loading"
                        >
                          Next
                        </v-btn>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <v-toolbar
          v-if="stepper != 1"
          class="fixed-bar"
          style="width: 100%; "
        >
          <v-btn
            v-if="stepper != 1 || stepper != 5"
            icon
            @click="previousPageControl"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title style="margin-left: 15px;">
            {{ titles[stepper] }}
          </v-toolbar-title>
        </v-toolbar>

        <!-- <v-app-bar  v-if="isMobile && stepper != 1" :elevation="3">
            <v-app-bar-title> {{ titles[stepper] }} </v-app-bar-title>

          </v-app-bar> -->

        <!-- <div v-if="isMobile()"> -->
        <v-col
          v-if="stepper == 1 && isMobile"
          lg="4"
          class="d-flex align-center pa-10 pb-0 hero"
        >
          <div style="position: absolute;bottom: 100px;width: 80%;">
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="12"
                class="mx-auto"
              >
                <v-btn
                  block
                  color="primary"
                  type="submit"
                  class="mt-6"
                  :loading="loading"
                  @click="stepper = 2"
                >
                  New User
                </v-btn>
                <v-btn
                  block
                  color="white"
                  type="submit"
                  class="mt-6"
                  :loading="loading"
                  @click="stepper = 7"
                >
                  Already Registered
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>

        <!-- terms & privacy Policy  -->
        <!-- class="d-flex align-center auth-bg pa-100 pb-0 closeToTop" -->
        <v-col
          v-if="stepper == 2 && isMobile"
          lg="4"
        >
          <!-- style="margin-top:-90% !important" -->
          <v-container class="card-container">
            <!-- style="margin-top: -100%;" -->
            <!-- <v-card
            v-scroll.self="onScroll"
            class="overflow-y-auto"
            height="800px"
            style="width: 100%;"
            > -->
            <v-card
              class="scroll"
              style="width: 100%;"
            >
              <v-card-text>
                <RichEditor
                  :remote-get-item="PPLatestRecord"
                  :check-content-value="checkContentValue"
                  disable-button
                >
                </RichEditor>

                <v-form
                  v-if="privacyContentChecked"
                  ref="privacyForm"
                  @submit.prevent="handlePrivacyFormSubmit"
                >
                  <div class="d-flex align-center justify-space-between flex-wrap">
                    <v-checkbox
                      v-model="privacyChecked"
                      hide-details
                      label="I have read and agreed to the Terms & Privacy Policy of this Application."
                      :rules="[v => !!v || 'Please check the box']"
                    >
                    </v-checkbox>
                  </div>
                  <!-- :loading="loading" -->
                  <v-btn
                    block
                    color="primary"
                    type="submit"
                    class="mt-6"
                  >
                    Next
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-container>
        </v-col>

        <!--acivation -->
        <v-col
          v-if="stepper == 3 && isMobile"
          class="d-flex auth-bg pa-10 pb-0 closeToTop"
          lg="4"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="12"
                class="mx-auto"
              >
                <v-card flat>
                  <v-card-text>
                    <p class="text-2xl font-weight-semibold text--primary mb-2">
                      Activation
                    </p>
                  </v-card-text>

                  <!-- login form -->
                  <v-card-text class="activationForm">
                    <v-form
                      ref="activationForm"
                      @submit.prevent="handleActivationFormSubmit"
                    >
                      <v-text-field
                        v-model="activationUserNo"
                        outlined
                        label="Membership No. or Mobile No."
                        placeholder="Membership No. or Mobile No."
                        :error-messages="errorMessages.activationUserNo"
                        :rules="[validators.lengthMoreThanValidator(activationUserNo, 10), validators.required]"
                        hide-details="auto"
                        class="mb-6"
                      ></v-text-field>
                      <v-text-field
                        v-model="activationHKID"
                        outlined
                        label="HKID"
                        :error-messages="errorMessages.activationHKID"
                        placeholder="HKID"
                        :rules="[validators.lengthValidator(activationHKID, 5), validators.required]"
                        hide-details="auto"
                        class="mb-2"
                        @click:append="isPasswordVisible = !isPasswordVisible"
                      ></v-text-field>
                      <div style="padding-top:0px;font-size:16px ;position: relative;">
                        e.g. Z123456(7) input as Z1234
                      </div>
                      <div class="d-flex align-center justify-space-between flex-wrap">
                        <v-btn
                          block
                          color="primary"
                          type="submit"
                          class="mt-6"
                          :loading="loading"
                        >
                          Next
                        </v-btn>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <!-- forgetpassword   -->
        <v-col
          v-if="stepper == 4 && isMobile"
          class="d-flex auth-bg pa-10 pb-0 closeToTop"
          lg="4"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="12"
                class="mx-auto"
              >
                <v-card flat>
                  <v-card-text>
                    <p class="text-2xl font-weight-semibold text--primary mb-2">
                      Forgot Password
                    </p>
                  </v-card-text>

                  <!-- login form -->
                  <v-card-text class="activationForm">
                    <v-form
                      ref="forgotPasswordForm"
                      @submit.prevent="handleForgotPasswordFormSubmit"
                    >
                      <v-text-field
                        v-model="activationUserNo"
                        outlined
                        label="Membership No. or Mobile No."
                        placeholder="Membership No. or Mobile No."
                        :error-messages="errorMessages.activationUserNo"
                        :rules="[validators.lengthMoreThanValidator(activationUserNo, 10), validators.required]"
                        hide-details="auto"
                        class="mb-6"
                      ></v-text-field>
                      <v-text-field
                        v-model="activationHKID"
                        outlined
                        label="HKID"
                        :error-messages="errorMessages.activationHKID"
                        placeholder="HKID"
                        :rules="[validators.lengthValidator(activationHKID, 5), validators.required]"
                        hide-details="auto"
                        class="mb-2"
                        @click:append="isPasswordVisible = !isPasswordVisible"
                      ></v-text-field>
                      <div style="padding-top:0px;font-size:16px ;position: relative;">
                        e.g. Z123456(7) input as Z1234
                      </div>
                      <div class="d-flex align-center justify-space-between flex-wrap">
                        <v-btn
                          block
                          color="primary"
                          type="submit"
                          class="mt-6"
                          :loading="loading"
                        >
                          Next
                        </v-btn>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <!--verfication -->
        <v-col
          v-if="stepper == 5 && isMobile"
          class="d-flex auth-bg closeToTop"
          lg="4"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="12"
                class="mx-auto"
              >
                <v-card flat>
                  <v-card-text>
                    <p class="text-2xl font-weight-semibold text--primary mb-2">
                      Enter 6-digit verification code
                    </p>
                  </v-card-text>
                  <v-card-text>
                    <CodeInput
                      style="margin-top: 30px;"
                      class="input"
                      @complete="verificationCodeComplete"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

          <v-overlay
            :z-index="999"
            :value="loading"
          >
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </v-col>

        <!-- change password -->
        <v-col
          v-if="stepper == 6 && isMobile"
          class="d-flex auth-bg closeToTop"
          lg="4"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="12"
                class="mx-auto"
              >
                <v-card flat>
                  <v-card-text>
                    <p class="text-2xl font-weight-semibold text--primary mb-2">
                      Activation
                    </p>
                  </v-card-text>

                  <v-card-text class="activationForm">
                    <v-form
                      ref="changePasswordForm"
                      @submit.prevent="handleChangePasswordFormSubmit"
                    >
                      <v-text-field
                        v-model="activationPassword"
                        outlined
                        :type="isPasswordVisible ? 'text' : 'password'"
                        label="Create Password"
                        :error-messages="errorMessages.activationPassword"
                        placeholder="Password"
                        :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
                        :rules="[v => {
                          if (!(contains_eight_characters &&
                            contains_special_character &&
                            contains_uppercase &&
                            contains_number)) return ''
                        }, validators.required]"
                        hide-details="auto"
                        class="mb-2"
                        @input="checkPassword"
                        @click:append="isPasswordVisible = !isPasswordVisible"
                      ></v-text-field>

                      <div>
                        <v-icon
                          v-if="contains_eight_characters"
                          color="#4CAF50"
                        >
                          {{ icons.mdiCheck }}
                        </v-icon>
                        <v-icon
                          v-else
                          color="#F44336"
                        >
                          {{ icons.mdiWindowClose }}
                        </v-icon>
                        At least 8 characters
                        <br>
                        <v-icon
                          v-if="contains_special_character"
                          color="#4CAF50"
                        >
                          {{ icons.mdiCheck }}
                        </v-icon>
                        <v-icon
                          v-else
                          color="#F44336"
                        >
                          {{ icons.mdiWindowClose }}
                        </v-icon>At least 1 specific character
                        !@#$%^&*
                        <br>
                        <v-icon
                          v-if="contains_uppercase"
                          color="#4CAF50"
                        >
                          {{ icons.mdiCheck }}
                        </v-icon>
                        <v-icon
                          v-else
                          color="#F44336"
                        >
                          {{ icons.mdiWindowClose }}
                        </v-icon>At least 1 uppercase character
                        <br>
                        <v-icon
                          v-if="contains_number"
                          color="#4CAF50"
                        >
                          {{ icons.mdiCheck }}
                        </v-icon>
                        <v-icon
                          v-else
                          color="#F44336"
                        >
                          {{ icons.mdiWindowClose }}
                        </v-icon>At least 1 numberic character
                        <br>
                      </div>

                      <v-text-field
                        v-model="activationConfirmedPassword"
                        style="padding-top:12px;"
                        outlined
                        :type="isPasswordVisible ? 'text' : 'password'"
                        label="Confirmed Password"
                        :error-messages="errorMessages.activationConfirmedPassword"
                        placeholder="Password"
                        :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
                        :rules="[activationPassword === activationConfirmedPassword || 'Please enter same password', validators.required]"
                        hide-details="auto"
                        class="mb-2"
                        @click:append="isPasswordVisible = !isPasswordVisible"
                      ></v-text-field>

                      <div class="d-flex align-center justify-space-between flex-wrap">
                        <v-btn
                          block
                          color="primary"
                          type="submit"
                          class="mt-6"
                          :loading="loading"
                        >
                          Next
                        </v-btn>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <v-col
          v-if="stepper == 7 && isMobile"
          class="d-flex align-center auth-bg pa-100 pb-0   closeToTop"
          lg="4"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="8"
                md="6"
                lg="12"
                class="mx-auto"
              >
                <v-card flat>
                  <v-card-text>
                    <p class="text-2xl font-weight-semibold text--primary mb-2">
                      Welcome to Asian Alliance
                    </p>
                    <p class="mb-2">
                      Membership / Staff No or MobileNo
               
                    </p>
                  </v-card-text>

                  <v-card-text>
                    <v-form
                      ref="loginForm"
                      @submit.prevent="handleFormSubmit"
                    >
                      <v-text-field
                        v-model="email"
                        outlined
                        label="Username"
                        placeholder="username"
                        :error-messages="errorMessages.username"
                        :rules="[validators.required]"
                        hide-details="auto"
                        class="mb-6"
                      ></v-text-field>

                      <v-text-field
                        v-model="password"
                        outlined
                        :type="isPasswordVisible ? 'text' : 'password'"
                        label="Password"
                        :error-messages="errorMessages.password"
                        placeholder="Password"
                        :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
                        :rules="[validators.required]"
                        hide-details="auto"
                        class="mb-2"
                        @click:append="isPasswordVisible = !isPasswordVisible"
                      ></v-text-field>

                      <div class="d-flex align-center justify-space-between flex-wrap">
                        <v-btn
                          block
                          color="primary"
                          type="submit"
                          class="mt-6"
                          :loading="loading"
                        >
                          Login
                        </v-btn>
                        <div style="padding-top:30px;">
                          <v-checkbox
                            hide-details
                            label="Remember Me"
                            class="mt-0"
                          >
                          </v-checkbox>
                        </div>
                        <div
                          style="padding-top:32px;font-size:16px ;position: relative;"
                          @click="stepper = 4"
                        >
                          <u>Forget Password?</u>
                        </div>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </div>

    <v-overlay
      :z-index="999"
      :value="loading"
    >
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { useRouter } from 'vue-router/composables'
import { emailValidator, required, lengthValidator, lengthMoreThanValidator, passwordValidator, confirmedValidator } from '@core/utils/validation'
import { mdiEyeOffOutline, mdiEyeOutline, mdiCheck, mdiWindowClose } from '@mdi/js'
import themeConfig from '@themeConfig'
import { getCurrentInstance, ref } from 'vue'
import CodeInput from '@/components/Verification/CodeInput.vue'
import sha512 from 'crypto-js/sha512'
import { useStore } from '@/store'
import RichEditor from '@/components/RichEditor/RichEditor.vue'

// import {loading as globalLoading} from '@/utils/helpers'
import { GetLatestRecord as PPLatestRecord } from '@/api/privacyPolicy'
import { Activation, ForgetPassword, ConfirmVerify, ChangePassword } from '@/api/user'

 
 

// import {backgoundImage} from '../assets/images/svg/background.svg'

// import { useI18n } from 'vue-i18n'
export default {
  components: {
    RichEditor,
    CodeInput,

  },
  data() {
    return {
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,
    }
  },

  data() {
    return {
      isMobile: false,
      titles: {
        1: 'Order Search',
        2: 'Terms & Privacy Policy',
        3: '', // acivation
        4: '', // forgetpassword
        5: '', // verfication code
        6: '', // change password
        7: '', // login
      },
    }
  },
  watch: {

    activationUserNo(NewValue, OldValue) {
      this.activationUserNo = NewValue.toUpperCase()
    },

    activationHKID(NewValue, OldValue) {
      this.activationHKID = NewValue.toUpperCase()
    },

    // $route(to, from) {
    //   if (to.params['stack-key-dir'] === 'forward') {
    //     this.transitionName = 'forward';
    //   } else {
    //     this.transitionName = 'back';
    //   }
    // }
  },

  created() {
    window.addEventListener('resize', this.myEventHandler)
    this.checkMonitorSize()
  },
  destroyed() {
    window.removeEventListener('resize', this.myEventHandler)
  },
  methods: {

    previousPageControl() {
      if (this.stepper == 7) {
        this.stepper = 1

        return
      }

      if (this.stepper == 4) {
        this.stepper = 7

        return
      }

      this.stepper -= 1
    },

    newUserActivation() {
      // this.stepper = 1
      this.$router.push({ path: '/forgot-password' })
    },

    myEventHandler(e) {
      this.checkMonitorSize()
    },

    checkContentValue(content) {
      console.log('checkContentValue', content)
      this.privacyContentChecked = true
    },

    checkMonitorSize() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        console.log('mobile')
        this.isMobile = true
      } else {
        console.log('desktop')
        this.isMobile = false
      }
    },

    checkPassword() {
      console.log('checkPassword')
      this.password_length = this.activationPassword.length
      const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/

      if (this.password_length >= 8) {
        this.contains_eight_characters = true
      } else {
        this.contains_eight_characters = false
      }

      this.contains_number = /\d/.test(this.activationPassword)
      this.contains_uppercase = /[A-Z]/.test(this.activationPassword)
      this.contains_special_character = format.test(this.activationPassword)

      if (this.contains_eight_characters === true
        && this.contains_special_character === true
        && this.contains_uppercase === true
        && this.contains_number === true) {
        this.valid_password = true
      } else {
        this.valid_password = false
      }
    },

  },
  setup() {
    // const { t } = useI18n({})
    // console.log('t', t)
    // Template Ref
    const loginForm = ref(null)

    const privacyForm = ref(null)
    const privacyChecked = ref(false)
    const privacyContentChecked = ref(false)

    const activationForm = ref(null)
    const activationUserNo = ref('')
    const activationHKID = ref('')
    const activationToken = ref('')

    const forgotPasswordForm = ref(null)

    const activationUserToken = ref('')

    const changePasswordForm = ref(null)
    const activationPassword = ref('')
    const activationConfirmedPassword = ref('')

    const vm = getCurrentInstance().proxy
    const router = useRouter()

    const isPasswordVisible = ref(false)

    // const email = ref('admin')
    // const username = ref('admin')

    // const password = ref('admin')
    const email = ref('')
    const username = ref('')

    const password = ref('')
    const errorMessages = ref([])

    const loading = ref(false)

    const store = useStore()

    const stepper = ref(1)

    const handlePrivacyFormSubmit = () => {
      const isFormValid = privacyForm.value.validate()
      console.log('isFormValid', isFormValid)
      if (!isFormValid) return
      stepper.value = 3
      privacyContentChecked.value = false
      privacyChecked.value = false
    }

    // stpper3
    const handleActivationFormSubmit = () => {
      const isFormValid = activationForm.value.validate()
      console.log('isFormValid', isFormValid)
      if (!isFormValid) return
      console.log('loading.value = true')
      loading.value = true
      const data = { Username: activationUserNo.value, HKID: activationHKID.value, VerifcationType: 2, locale: 'tc' }
      Activation(data).then(response => {
        loading.value = false
        if (response.code == 20000) {
          const { data } = response
          stepper.value = 5
          console.log(response)

          activationHKID.value = ''
          activationToken.value = data.record
        }
      })
        .catch(err => {
          loading.value = false

          // alert(err)
        })
    }

    // stepper4
    const handleForgotPasswordFormSubmit = () => {
      const isFormValid = forgotPasswordForm.value.validate()
      console.log('isFormValid', isFormValid)
      if (!isFormValid) return
      console.log('loading.value = true')
      loading.value = true
      const data = { Username: activationUserNo.value, HKID: activationHKID.value, VerifcationType: 2, locale: 'tc' }
      ForgetPassword(data).then(response => {
        loading.value = false
        if (response.code == 20000) {
          const { data } = response
          stepper.value = 5
          console.log(response)

          activationHKID.value = ''
          activationToken.value = data.record
        }
      })
        .catch(err => {
          loading.value = false

          // alert(err)
        })
    }

    // stepper5
    const verificationCodeComplete = value => {
      console.log('verificationCodeComplete', value)
      handleVerificationSubmit(value)
    }

    const handleVerificationSubmit = data => {
      loading.value = true

      ConfirmVerify({ VerifcationCode: data, ActivationToken: activationToken.value }).then(response => {
        loading.value = false
        if (response.code == 20000) {
          stepper.value = 6
          const { data } = response
          activationUserToken.value = data.record
        }
      })
        .catch(err => {
          loading.value = false
        })
    }

    // stepper6 changepassord
    const handleChangePasswordFormSubmit = () => {
      const isFormValid = changePasswordForm.value.validate()
      console.log('isFormValid', isFormValid)
      if (!isFormValid) return
      loading.value = true
      changePasswordForm.value.resetValidation()

      ChangePassword({ ConfirmedPasswordSha: sha512(activationConfirmedPassword.value.trim()).toString(), UserToken: activationUserToken.value }).then(response => {
        if (response.code == 20000) {
          internalLogin()
        }
      })
        .catch(err => {
          loading.value = false
        })
    }

    const resetAllValue = () => {
      activationUserNo.value = ''
      activationHKID.value = ''
      activationToken.value = ''
      activationUserToken.value = ''
      activationPassword.value = ''
      activationConfirmedPassword.value = ''
      loading.value = false
    }

    const internalLogin = () => {
      store
        .dispatch('users/login', { username: activationUserNo.value.trim(), password: activationConfirmedPassword.value })
        .then(result => {
          // t.locale = 'tc'
          console.log('result', result)
          store.dispatch('sysRoleMenus/updateMenus', result.sysRoleMenuList).then(menus => {
            console.log('store menus', menus)
          })

          // const tempString = localStorage.getItem('userData')
          // console.log('tempString', tempString)
          // result.record.
          // delete user.ability
          // vm.$session.set('companyConfig', result.companyConfig)
          // const config = vm.$session.get('companyConfig')
          // console.log('config', config)

          // this.$router.push({ path: this.redirect || '/org/management' })
          if (result.userRecord) {
            const { userRecord } = result
            if (userRecord.sysUserRoles.length > 0) {
              const sysUserRole = userRecord.sysUserRoles[0]
              const coachRoleIds = [2, 3, 4]
              const managementRoleIds = [5, 7]

              try {
                const userDataForReactNative = window.localStorage.getItem('userData')
                window.ReactNativeWebView.postMessage('action:uploadFCM')
                window.ReactNativeWebView.postMessage(userDataForReactNative)
              } catch (err) {

              }

              // console.log('sysUserRole', sysUserRole)
              if (sysUserRole.sysRoleID === 6) {
                router.push('/COACH_Create_Order')
              } else if (coachRoleIds.indexOf(sysUserRole.sysRoleID) >= 0) {
                router.push('/COACH_Booking_Calendar')
              } else if (managementRoleIds.indexOf(sysUserRole.sysRoleID) >= 0) {
                router.push('/MANAGE_Coach_Profiles')
              } else if (sysUserRole.sysRoleID === 1) {
                router.push('/STUDENT_Booking_Calendar')
              } else {
                router.push('/STUDENT_PLAYGROUND')
              }
            } else {
              router.push('/STUDENT_Profile')
            }
          }
        })
        .finally(() => {
          resetAllValue()
        })
    }

    const handleFormSubmit = () => {
      const isFormValid = loginForm.value.validate()
      let logined = false
      if (!isFormValid) return

      loading.value = true
      store
        .dispatch('users/login', { username: email.value.trim(), password: password.value.trim() })
        .then(result => {
          // t.locale = 'tc'
          console.log('result', result)
          store.dispatch('sysRoleMenus/updateMenus', result.sysRoleMenuList).then(menus => {
            console.log('store menus', menus)
          })

          // const tempString = localStorage.getItem('userData')
          // console.log('tempString', tempString)
          // result.record.
          // delete user.ability
          // vm.$session.set('companyConfig', result.companyConfig)
          // const config = vm.$session.get('companyConfig')
          // console.log('config', config)

          // this.$router.push({ path: this.redirect || '/org/management' })
          if (result.userRecord) {
            const { userRecord } = result
            if (userRecord.sysUserRoles.length > 0) {
              const sysUserRole = userRecord.sysUserRoles[0]
              const coachRoleIds = [2, 3, 4]
              const managementRoleIds = [5, 7]



              // console.log('sysUserRole', sysUserRole)
              if (sysUserRole.sysRoleID === 6) {
                router.push('/COACH_Create_Order')
              } else if (coachRoleIds.indexOf(sysUserRole.sysRoleID) >= 0) {
                router.push('/COACH_Booking_Calendar')
              } else if (managementRoleIds.indexOf(sysUserRole.sysRoleID) >= 0) {
                router.push('/MANAGE_Coach_Profiles')
              } else if (sysUserRole.sysRoleID === 1) {
                router.push('/STUDENT_Booking_Calendar')
              } else {
                router.push('/STUDENT_PLAYGROUND')
              }

              logined = true
            } else {
              router.push('/STUDENT_Profile')
            }
          }
        })
        .finally(() => {
          loading.value = false

          if (logined){
            try {
                const userDataForReactNative = window.localStorage.getItem('userData')
                window.ReactNativeWebView.postMessage('action:uploadFCM')
                window.ReactNativeWebView.postMessage(userDataForReactNative)
              } catch (err) {

              }
          }
        })
    }

    return {
      handleFormSubmit,
      handlePrivacyFormSubmit,
      PPLatestRecord,

      activationForm,
      activationUserNo,
      activationHKID,
      handleActivationFormSubmit,
      activationToken,

      forgotPasswordForm,
      handleForgotPasswordFormSubmit,

      handleVerificationSubmit,
      verificationCodeComplete,
      activationUserToken,

      changePasswordForm,
      activationPassword,
      activationConfirmedPassword,
      handleChangePasswordFormSubmit,

      isPasswordVisible,
      email,
      password,
      errorMessages,
      stepper,
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
        mdiCheck,
        mdiWindowClose,
      },
      validators: {
        required,
        emailValidator,
        lengthValidator,
        lengthMoreThanValidator,
        passwordValidator,
        confirmedValidator,
      },

      // themeConfig
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      // Template Refs
      loginForm,
      privacyForm,
      privacyChecked,
      privacyContentChecked,

      loading,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@core/preset/preset/pages/auth.scss';
</style>

<style>
.hero {
  background: url('../../src/assets/images/AsianAlliance/mobile-background.png');
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

}

.closeToTop {
  /* margin-top: -100%;*/

  height: 100vh;
  overflow-y: hidden;

}

.fixed-bar {
  position: sticky;
  position: -webkit-sticky;
  /* for Safari */
  top: 0em;
  z-index: 2;
}

.scroll {
  /* overflow-y: scroll  */
}

.card-container {
  height: calc(100vh - 64px);
  /* subtract toolbar height (64px) from viewport height */
  overflow: auto;
}

.top {
  position: absolute;
  right: 0px;
  width: 100%;
  border: 3px solid #73AD21;
  padding: 10px;
}

.activationForm {
  top: 80px;
  position: absolute;
}
</style>
